import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useState } from "react";
import axiosInstance from "../../../axios-instance";
import Loader from "../../../components/Loader/Loader";
import { notification } from "../../../utils/utility";
import { getAdminBusinessId } from "../../../utils/authHelper";

const CardForm = ({ onClose, selectedPlan, planPeriodType, getUserAndPlans }) => {
 
  const [isLoading, setIsLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const CARD_ELEMENT_OPTIONS = {
    hidePostalCode: true,
    style: {
        base: {
          fontSize: "16px",
          color: "#32325d",
          fontFamily: "Inter, Arial, sans-serif",
          "::placeholder": {
              color: "#a0aec0",
          },
        },
        invalid: {
          color: "#e53e3e",
        },
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!stripe || !elements) return;
    setLoading(true);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });
    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }
    
    const res = await axiosInstance.post("/admin/subscription/create", {
      payment_method_id: paymentMethod.id,
      plan_id: selectedPlan.id,
      plan_type: planPeriodType,
      business_id: getAdminBusinessId()
    });

    if (res.data.success) {
      const result = await stripe.confirmCardPayment(res.data.client_secret, {
        payment_method: {
          card: elements.getElement(CardElement),
        }
      });
      if (result.error) {
        setError(result.error.message);
      } else {
        if (result.paymentIntent.status === 'succeeded') {
          // Payment successful
          notification.success("Successfully subscribed to plan");
          setIsLoading(true);
          setTimeout(() => {
              setIsLoading(false);
              getUserAndPlans();
              setLoading(false);
              onClose();
          }, 15000);
        }
      }
    }
    
  };

  return (
    <>
      <Loader isShowLoader={isLoading} loadingText="Please wait, your subscription is being created. This may take a few moments."/>
      <form onSubmit={handleSubmit} className="p-4">
        <div className="stripe-card-wrapper mb-3">
          <CardElement options={CARD_ELEMENT_OPTIONS} />
        </div>
        {error && <p className="text-danger mt-2">{error}</p>}
        <button className="btn btn-app mt-4" disabled={loading || !stripe}>
          {loading ? "Processing..." : "Enter Card Detail and Subscribe"}
        </button>
      </form>
    </>
  );
};

export default CardForm;
